import SiteHeader from '@/components/feature/SiteHeader';
import SiteFooter from '@/components/feature/SiteFooter';
import SectionTitle from '@/components/base/SectionTitle';
import { dramas, specials } from '@/mocks/dramas';
import type { Drama } from '@/types/drama';
import HeroCarousel from './components/HeroCarousel';
import QuickLinks from './components/QuickLinks';
import LatestGrid from './components/LatestGrid';
import RankingList from './components/RankingList';
import SpecialSpotlight from './components/SpecialSpotlight';
import IntroSection from './components/IntroSection';

export default function Home() {
  const allDramas = dramas as Drama[];

  const featured = allDramas.filter((d) => d.featured).slice(0, 4);
  const latest = [...allDramas]
    .sort((a, b) => b.updatedAt.localeCompare(a.updatedAt))
    .slice(0, 8);
  const ranking = [...allDramas].sort((a, b) => b.views - a.views).slice(0, 8);

  const dramaLookup = (id: string) => allDramas.find((d) => d.id === id)?.title ?? '';

  return (
    <div className="flex min-h-screen flex-col bg-background-50">
      <SiteHeader />

      <main className="flex-1">
        <HeroCarousel slides={featured} />

        <div className="mx-auto flex w-full max-w-[1200px] flex-col gap-14 py-12 md:gap-20 md:py-16">
          <QuickLinks />

          <LatestGrid dramas={latest} />

          <section className="mx-auto w-full max-w-[1200px] px-4 md:px-6">
            <SectionTitle
              eyebrow="热度排行"
              title="本周热门伦理剧榜单"
              description="综合播放热度与观众评分排序，本周最受关注的伦理剧作品一榜看尽。"
              action={{ label: '查看热门推荐', to: '/category/popular' }}
            />
            <RankingList dramas={ranking} wide />
          </section>

          <SpecialSpotlight specials={specials} dramaLookup={dramaLookup} />

          <IntroSection dramaCount={allDramas.length} specialCount={specials.length} />
        </div>
      </main>

      <SiteFooter />
    </div>
  );
}